import { inject } from '@angular/core';
import { AuthService, AnalyticsService } from 'src/services';

export const appInitializer = () => {
  const authService = inject(AuthService);
  const analyticsService = inject(AnalyticsService);

  // Initialize analytics service
  analyticsService.initialize();

  return authService.initialize();
};
